import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { HeaderInputProps } from "./HeaderInputProps";

export default function HeaderInput(props: Readonly<HeaderInputProps>) {
  return (
    <Box>
      <Typography
        sx={{
          m: 0,
          fontSize: "1rem",
        }}
      >
        {props.text}
        {
          props.required ? (
            <span style={{ color: "red" }}> *</span>
          ) : null
        }
      </Typography>
      {
        props.subtext && (
          <Typography
            className='Sub-title-form'
            sx={props.sxSubText}
          >
            {props.subtext}
          </Typography>
        )
      }
      {
        props.IsTooltip && (
          <>{props.tooltip}</>
        )
      }
    </Box>
  );
}

const defaultProp: HeaderInputProps = {
  IsTooltip: false,
  text: "",
  tooltip: <></>,
  id: "",
}
HeaderInput.defaultProps = defaultProp;


